module.exports = __webpack_public_path__ + "static/media/img-goal-17.27ff9973.jpg";